export default __webpack_public_path__ + "static/media/Bg1.3e688564.jpg";